import { getImagenUrl } from '../../shared/api';
import { buildTicketLines, mergeConfig, STYLE_CLASS, ticketCss } from './ticketLayout';

// Ancho real del ticket en 80mm. Se usa en la vista previa para que sea identica
// al papel (la fuente monospace a 42 columnas ocupa ~302px).
export const TICKET_PREVIEW_WIDTH = 302;

// Resuelve el logo efectivo: logo personalizado del ticket > logo de la empresa.
export function effectiveLogo(recibo) {
  const cfg = mergeConfig(recibo?.ticket_config);
  if (!cfg.usar_logo) return null;
  return cfg.logo_url || recibo?.logo_url || null;
}

// Renderiza el ticket exactamente igual que la ventana de impresión (logo + lineas
// + mismos estilos/fuente). Se usa tanto en la vista previa de configuración como
// en el modal TicketImprimir, para que "lo que ves es lo que sale".
export default function TicketCanvas({ recibo, modo, monedasSel, incluirIva, width = TICKET_PREVIEW_WIDTH }) {
  const cfg = mergeConfig(recibo?.ticket_config);
  const lines = buildTicketLines(recibo, modo, monedasSel, incluirIva);
  const logoUrl = getImagenUrl(effectiveLogo(recibo));

  const renderLine = (ln, i) => {
    if (ln.kind === 'divider') {
      return <div key={i} className="divider" />;
    }
    if (ln.kind === 'pair') {
      const cls = `pair ${STYLE_CLASS[ln.style] || ''}`.trim();
      return (
        <div key={i} className={cls}>
          <span className="left">{ln.left}</span>
          <span className={`fill${ln.dotted ? ' dots' : ''}`} />
          <span className="right">{ln.right}</span>
        </div>
      );
    }
    return (
      <div key={i} className={`line ${STYLE_CLASS[ln.style] || ''}`}>
        {ln.text}
      </div>
    );
  };

  return (
    <div style={{ width, maxWidth: '100%', margin: '0 auto' }}>
      <style>{ticketCss(cfg)}</style>
      <div className="agx-ticket" style={{ padding: '2mm', boxSizing: 'border-box', background: '#fff' }}>
        {logoUrl && (
          <div className="logo">
            <img src={logoUrl} alt="logo" onError={(e) => (e.currentTarget.style.display = 'none')} />
          </div>
        )}
        {lines.map(renderLine)}
      </div>
    </div>
  );
}
